import axios from 'axios';
import {
    UserCompanyRequest,
    UserCompanyResponse,
    UpdateUserCompanyMappingRequest,
    AddUserRequest,
    IAddInviteRequest,
    PutUserCompanyMappingResult
} from '../schemas';

export async function getAll(params: UserCompanyRequest) {
    return axios.get<UserCompanyResponse>('/v1/user/company', {
        params,
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH')
        }
    });
}

export async function getAllV2(params: UserCompanyRequest, options?: { signal?: AbortSignal }) {
    return axios.get<UserCompanyResponse>('/v2/user/company', {
        signal: options?.signal,
        params,
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH')
        }
    });
}

export async function updateUsersStatus(params: UpdateUserCompanyMappingRequest) {
    return axios.put<PutUserCompanyMappingResult>('/v2/user/company', params, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH')
        }
    });
}

export async function updateUsersStatusWithEmployeeInformation(
    body: UpdateUserCompanyMappingRequest
) {
    return axios.put<PutUserCompanyMappingResult>('/v2/user/company', body, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH')
        }
    });
}

export async function requestAddUser(body: AddUserRequest) {
    return axios.post('/v2/user/company', body, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH')
        }
    });
}

export async function requestAddUsers(body: AddUserRequest[]) {
    return axios.post('/v1/user/company', body, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH')
        }
    });
}

export async function requestAddInvite(body: IAddInviteRequest[]) {
    return axios.post('v1/user/company/admin/invite', body, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH')
        }
    });
}

export async function requestSendApprovalResultEmail(body: UpdateUserCompanyMappingRequest) {
    return axios.post('v1/send-approval-result-email', body, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH')
        }
    });
}
